import axios from 'axios';
import * as _ from 'lodash';

import Chat from 'src/components/Chat/Chat';
import ChatReply from 'src/components/ChatReply/ChatReply';

import {
    IChatCancelCommand,
    IChatCreateCommand,
    IChatInfo,
    IChatReplyCommand,
    IHandlerPerson,
    IShowChatParams,
    IShowChatReplyParams
} from 'src/models';

import userService from './user.service';
import commonService from './common.service';
import auditService from './audit.service';
import toasterService from './toaster.service';


export default {
    chatComponent: null,
    chatReplyComponent: null,

    dispose() {
        if (this.chatComponent) {
            this.chatComponent.dispose();
        }
        this.chatComponent = null;

        if (this.chatReplyComponent) {
            this.chatReplyComponent.dispose();
        }
        this.chatReplyComponent = null;
    },

    // 显示沟通
    showChat(params: IShowChatParams) {
        if (!this.chatComponent) {
            this.chatComponent = new Chat({
                source: '<x-chat></x-chat>'
            });
            this.chatComponent.attach(document.body);
        }
        this.chatComponent.show(params)
    },

    // 显示取消沟通
    showChatReply(params: IShowChatReplyParams) {
        if (!this.chatReplyComponent) {
            this.chatReplyComponent = new ChatReply({
                source: '<x-chat-reply></x-chat-reply>'
            });
            this.chatReplyComponent.attach(document.body);
        }
        this.chatReplyComponent.show(params)
    },

    // 发起|追加 沟通
    createChat(auditId: string, chatInfo: IChatInfo): Promise<boolean> {
        // 获取当前工作流节点上的当前用户的信息（包含沟通信息）
        let currentPerson: IHandlerPerson;
        return Promise.all([
            userService.getCurrentUser(),
            auditService.getAuditWorkflowCurrentStepPersons(auditId)
        ]).then(results => {
            const currentUser: IHandlerPerson = results[0];
            const workflowCurrentStepPersons: IHandlerPerson[] = results[1];
            currentPerson = _.find(workflowCurrentStepPersons, { user_id: currentUser.user_id });
            // is_chatting 为 true，说明当前正在沟通中，再发起沟通，此时是追加沟通，使用原来的chatting_room_id
            // is_chatting 为 false，说明为发起沟通，或沟通已回复完成，此时是新建沟通，分配新的chatting_room_id
            // (is_chatting === !audit.is_can_chat， 二者同步)
            return currentPerson.is_chatting
                ? Promise.resolve(currentPerson.chatting_room_id)
                : commonService.getNewId();
        }).then(chatId => {
            const chatCreateCommand: IChatCreateCommand = {
                ...chatInfo,
                audit_id: auditId,    // 审批流 ID
                chat_id: chatId,  // 聊天室 ID
                user_id: currentPerson.user_id    // 发起人账号
            };
            return axios.post<boolean>(`/api/audits/chats/start`, chatCreateCommand);
        }).then(res => res.data);
    },

    // 取消沟通
    cancelChat(auditId: string): Promise<boolean> {
        // 获取当前工作流节点上的当前用户的信息（包含沟通信息）
        return Promise.all([
            userService.getCurrentUser(),
            auditService.getAuditWorkflowCurrentStepPersons(auditId)
        ]).then(results => {
            const currentUser: IHandlerPerson = results[0];
            const workflowCurrentStepPersons: IHandlerPerson[] = results[1];
            const currentPerson = _.find(workflowCurrentStepPersons, { user_id: currentUser.user_id });
            // 正在沟通中可撤回，否则不可撤回
            if (currentPerson.is_chatting) {
                const command: IChatCancelCommand = {
                    chat_id: currentPerson.chatting_room_id,
                    user_id: currentPerson.user_id
                };
                return axios.put<boolean>(`/api/audits/chats/${command.chat_id}/cancel`, command).then(res => !!res.data);
            } else {
                toasterService.show({
                    type: 'danger',
                    title: '当前用户没有正在进行的沟通，无法撤回'
                });
                return false;
            }
        });
    },

    // 回复沟通
    replyChat(command: IChatReplyCommand): Promise<boolean> {
        return userService.getCurrentUser()
            .then(currentUser => {
                command.user_id = currentUser.user_id;
                return axios.put<boolean>(`/api/audits/chats/${command.chat_id}/reply`, command)
            }).then(res => res.data);
    },

    // 是否当前用户有已发起的沟通（正在进行中，没有取消或全部被回复）
    getIsCurrentUserStartedChat(workflowCurrentStepPersons: IHandlerPerson[]): Promise<boolean> {
        // 获取当前工作流节点上的当前用户的信息（包含沟通信息）
        return userService.getCurrentUser().then(currentUser => {
            const currentPerson = _.find(workflowCurrentStepPersons, { user_id: currentUser.user_id });
            return currentPerson && currentPerson.is_chatting;
        });
    }
};
